import { render, staticRenderFns } from "./WechatBot.vue?vue&type=template&id=9fe50b22&"
import script from "./WechatBot.vue?vue&type=script&lang=js&"
export * from "./WechatBot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports